import { Component, input, inject } from '@angular/core';

import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';
import { CopyableTextDisplayComponent } from './copyable-text-display.component';

/**
 * Renders an `organizationSiteKey` as the site's name - the raw key means
 * nothing to the user. Falls back to the key for sites outside the session.
 */
@Component({
    selector: 'app-organization-site-name-display',
    template: `<app-copyable-text-display [value]="siteName" />`,
    standalone: true,
    imports: [CopyableTextDisplayComponent],
})
export class OrganizationSiteNameDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    private sessionService = inject(SessionService);

    /** A getter, not a computed: the session's site list is a plain array. */
    get siteName(): string {
        return this.sessionService.getOrganizationSiteName(
            String(this.value() || '')
        );
    }
}
